import { CommonModule } from "@angular/common";
import { Component, computed, effect } from "@angular/core";
import { RouterLink, RouterOutlet } from "@angular/router";
import { TranslocoPipe } from "@jsverse/transloco";
import { defer } from "lodash-es";
import { NzAvatarComponent } from "ng-zorro-antd/avatar";
import {
	NzDropdownDirective,
	NzDropdownMenuComponent,
} from "ng-zorro-antd/dropdown";
import { NzIconModule } from "ng-zorro-antd/icon";
import { NzLayoutModule } from "ng-zorro-antd/layout";
import { NzMenuModule } from "ng-zorro-antd/menu";
import { NzPopconfirmDirective } from "ng-zorro-antd/popconfirm";
import { AuthApi } from "../../../domain/api/auth.api";
import { CompanyApi } from "../../../domain/api/company.api";
import { NotificationApi } from "../../../domain/api/notification.api";
import { UserApi } from "../../../domain/api/user.api";
import { Notification } from "../../../domain/model/notification.model";
import { Router } from "../../../domain/service/router/router";
import { BaseComponent } from "../../shared/components/base.component";
import { LayoutCompanyLogoComponent } from "../../shared/components/layout-company-logo.component";
import { NotificationsToolbarComponent } from "../../shared/components/notifications-toolbar.component";
import { CdnPipe } from "../../shared/pipe/cdn.pipe";
import { FilePipe } from "../../shared/pipe/file.pipe";

@Component({
	selector: "app-layout-factory",
	imports: [
		CommonModule,
		RouterOutlet,
		NzIconModule,
		NzLayoutModule,
		NzMenuModule,
		RouterLink,
		NzDropdownMenuComponent,
		NzDropdownDirective,
		NzPopconfirmDirective,
		CdnPipe,
		NzAvatarComponent,
		NotificationsToolbarComponent,
		FilePipe,
		LayoutCompanyLogoComponent,
		TranslocoPipe,
	],
	template: `
    <nz-layout class="app-layout">
      <nz-sider class="menu-sidebar"
                nzCollapsible
                nzWidth="256px"
                nzBreakpoint="md"
                [(nzCollapsed)]="isCollapsed"
                [nzTrigger]="null">
        <app-layout-company-logo [company]="company()"/>
        <ul nz-menu nzTheme="light" nzMode="inline" [nzInlineCollapsed]="isCollapsed">
          <li nz-menu-item nzMatchRouter>
            <a [routerLink]="['/factory','inicio' ]">
              <span nz-icon nzType="home" class="pr-2"></span>
              <span>{{ 'layout.menu.home' | transloco }}</span>
            </a>
          </li>
          <li nz-submenu nzOpen [nzTitle]="'layout.menu.orders' | transloco" nzIcon="book">
            <ul>
              <li nz-menu-item nzMatchRouter>
                <a [routerLink]="['/factory','order','create' ]"><span class="pr-2" nz-icon
                                                                       [nzType]="'plus-circle'"></span>{{ 'layout.menu.newOrder' | transloco }}</a>
              </li>
              <li nz-menu-item nzMatchRouter>
                <a [routerLink]="['/factory','order','list','all' ]"><span class="pr-2" nz-icon
                                                                           [nzType]="'unordered-list'"></span>{{ 'layout.menu.orderList' | transloco }}</a>
              </li>
            </ul>
          </li>
          <ul nz-menu nzTheme="light" nzMode="inline" [nzInlineCollapsed]="isCollapsed">
            <li nz-menu-item nzMatchRouter>
              <a [routerLink]="['/factory','company','list','client' ]">
                <span nz-icon nzType="user" class="pr-2"></span>
                <span>{{ 'layout.menu.stores' | transloco }}</span>
              </a>
            </li>
          </ul>
        </ul>
      </nz-sider>
      <nz-layout id="inner-layout">
        <nz-header>
          <div class="app-header flex justify-between">
            <div>
                 <span class="header-trigger" (click)="isCollapsed = !isCollapsed">
                  <span class="trigger"
                        nz-icon
                        [nzType]="isCollapsed ? 'menu-unfold' : 'menu-fold'"
                  ></span> </span>
            </div>
            <div class="h-full flex items-center gap-6">
              <div>
                <app-notifications-toolbar [myNotifications]="myNotifications"/>
              </div>
              <div class="flex items-center gap-1 font-bold cursor-pointer" nz-dropdown [nzDropdownMenu]="menu"
                   [nzClickHide]="false">
                <nz-avatar class="mr-2" nzIcon="user"
                           [nzSrc]="(me()?.profileImageId || '') | filePath | cdn "></nz-avatar>

                {{ me()?.email ?? ('layout.userMenu.defaultUserName' | transloco) }}
              </div>
              <nz-dropdown-menu #menu="nzDropdownMenu">
                <ul nz-menu>
                  <li nz-menu-item (click)="profile()">
                    <span class="pr-2 " nz-icon [nzType]="'profile'" [nzTheme]="'twotone'"></span> {{ 'layout.userMenu.profile' | transloco }}
                  </li>

                  <li nz-menu-item nz-popconfirm
                      [nzPopconfirmTitle]="'layout.userMenu.logoutConfirm' | transloco"
                      (nzOnConfirm)="logout()"
                      nzPopconfirmPlacement="left">
                    <span class="pr-2 " nz-icon [nzType]="'close-circle'" [nzTheme]="'twotone'"
                          [nzTwotoneColor]="'#eb2f96'"></span> {{ 'layout.userMenu.logout' | transloco }}
                  </li>
                </ul>
              </nz-dropdown-menu>
            </div>

          </div>
        </nz-header>
        <nz-content>
          <div class="inner-content-scroll">
            <div class="inner-content">
              <router-outlet></router-outlet>
            </div>
          </div>
        </nz-content>
      </nz-layout>
    </nz-layout>
  `,
	styles: [
		`:host {
      display: flex;
      text-rendering: optimizeLegibility;
      -webkit-font-smoothing: antialiased;
      -moz-osx-font-smoothing: grayscale;
    }

    .app-layout {
      height: 100vh;
    }

    .menu-sidebar {
      position: relative;
      z-index: 10;
      min-height: 100vh;
      box-shadow: 2px 0 6px rgba(0,21,41,.35);
    }

    .header-trigger {
      height: 64px;
      padding: 20px 24px;
      font-size: 20px;
      cursor: pointer;
      transition: all .3s,padding 0s;
    }

    .app-header {
      position: relative;
      height: 64px;
      padding: 0;
      padding-right: 20px;
      background: #fff;
      box-shadow: 0 1px 4px rgba(0,21,41,.08);
    }

    .trigger:hover {
      color: #1890ff;
    }



    .sidebar-logo img {
      display: inline-block;
      vertical-align: middle;
    }

    .sidebar-logo h1 {
      display: inline-block;
      margin: 0 0 0 20px;
      color: #fff;
      font-weight: 600;
      font-size: 14px;
      font-family: Avenir,Helvetica Neue,Arial,Helvetica,sans-serif;
      vertical-align: middle;
    }

    nz-header {
      padding: 0;
      width: 100%;
      z-index: 2;
    }

    .inner-content-scroll {
      overflow: auto;
      height: 100%;
    }

    .inner-content {
      padding: 24px;
      height: 100%;
    }
    `,
	],
})
export class FactoryLayoutComponent extends BaseComponent {
	isCollapsed = false;
	users = this.userApi.all();
	me = computed(() =>
		this.users().find((user) => user.id === this.authApi.me()()!.id),
	);
	authMe = this.authApi.me();

	notifications = this.notificationApi.all();
	company = this.companyApi.byId(this.authMe()!.companyId);

	myNotifications: Notification[] | undefined = [];
	constructor(
		private readonly authApi: AuthApi,
		private readonly router: Router,
		private readonly userApi: UserApi,
		private readonly notificationApi: NotificationApi,
		private readonly companyApi: CompanyApi,
	) {
		super();
		effect(() => {
			if (this.notifications()) {
				this.myNotifications = this.notifications()?.filter(
					(n) => this.authMe()?.id === n.userId && !n.read,
				);
			}
		});
	}

	override onInit() {
		defer(
			async () =>
				await Promise.all([
					this.userApi.fetch(this.authMe()!.id),
					this.notificationApi.fetchByUserId(this.authMe()!.id),
					this.companyApi.fetch(this.authMe()!.companyId),
				]),
		);
	}
	async logout(): Promise<void> {
		await this.authApi.logout();
		await this.router.goToLogin();
	}
	async profile(): Promise<void> {
		await this.router.navigate(["/" + this.router.namespace(), "profile"]);
	}
}
